import React from 'react';
import './css/EventSkeletonLoader.css';

function EventSkeletonLoader() {
  return (
    <div className="event-skeleton-loader">
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div className="skeleton-event-box" key={index}>
            <div className="skeleton-header"></div>
            <div className="skeleton-body">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default EventSkeletonLoader;